module.exports = __webpack_public_path__ + "img/guarantee.8470c820.svg";